import styled, { css } from 'styled-components';
import Heading from 'core/components/Heading';
import { getColor, round, typeScale, StyleVars } from "core/utils";

export const Wrapper = styled.section`
	padding: 16px 0;

	@media(max-width: ${StyleVars.screenSm}) {
		padding: ${typeScale(1)} 0;
	}
`;

export const Cards = styled.div`
	padding: ${typeScale(1)} 0;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 16px;

	@media (min-width: 780px) {
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 32px 16px;
		padding-left: 16px;
	}
`;

export const Card = styled.a`
	display: block;

	figure {
		padding-top: ${({ collection }) => collection ? "40%" : "60%"};
		border-radius: 8px;
	}

	img {
		position: absolute;
		left: 0;
		top: 0;

		${({ collection }) => collection && css`
			object-position: right;
		`}
	}
`;

export const CardDate = styled.p`
	margin: 0;
	color: ${getColor('dustyGray')};
	margin-top: 4px;
	letter-spacing: 0.2px;
	font-size: 14px;
	line-height: ${round(18/14)};
	font-weight: 600;
`;

export const Title = styled.h4`
	margin: 0;
	color: ${getColor("gray")};
	font-size: 16px;
	line-height: ${round(20/16)};
	margin-top: 8px;
	font-weight: 600;

	@media (min-width: 780px) {
		margin-top: 16px;
	}
`;

export const ListicleCardsHeading = styled(Heading)`
	margin: 0;
	padding-bottom: 16px;

	@media(max-width: ${StyleVars.screenSm}) {
		padding-bottom: ${typeScale(1)};
	}
`;
